import { useIntl, FormattedMessage } from 'react-intl';
import Edit from 'src/componentes/edit/edit-dialog';
import Geral from './geral';
import { Schema } from 'src/utils/form';
import useAuth from 'src/hooks/useAuth';

const schema = Schema.object({
  descricao: Schema.string().required(),
  funcionalidades: Schema.string().required(),
  cor: Schema.string()
    .required()
    .label(<FormattedMessage id="cor" />),
});

const EditForm = ({ model }) => {
  return <Geral model={model} />;
};

const EditView = (props) => {
  const { terms: resources } = useAuth();
  const intl = useIntl();

  return (
    <Edit
      {...props}
      url="/Tag"
      title={intl.formatMessage({ id: 'tags' }, { tags: resources.tags })}
      schema={schema}
      formComponent={EditForm}
      width="60%"
      height="500px !important"
      intl={intl}
      showExport={false}
    />
  );
};

export default EditView;
